import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AutoPrintReprintService {

  private logisticsBaseUrl: string = `${environment.logisticsApiUrl}/print`;


  constructor(
    private http: HttpClient
  ) { }

  getPrinterCode(facility:string):Observable<any>{
    const url = this.logisticsBaseUrl + `/getPrinterByFacility/${facility}`;
    return this.http.get(url);
  }

  getDocType(facility:string):Observable<any>{
    const url = this.logisticsBaseUrl + `/getDocTypeByFacility/${facility}`;
    return this.http.get(url);
  }

  reprintAutoPrint(params:any):Observable<any>{
    const url = this.logisticsBaseUrl + `/reprintAutoPrint`;
    return this.http.post(url,params);
  }

}
